import { Route, Routes } from 'react-router-dom';
import type { UserManager } from 'oidc-client-ts';
import type { AppConfig } from './config';
import { Home } from './pages/Home';
import { SectionPage } from './pages/SectionPage';
import { FormPage } from './pages/FormPage';
import { NotFound } from './pages/NotFound';
import { AuthCallback } from './pages/AuthCallback';
import { AccessDenied } from './pages/AccessDenied';
import { AuthGate } from './admin/AuthGate';
import { AdminLayout } from './admin/AdminLayout';
import { Dashboard } from './admin/Dashboard';
import { AuditLog } from './admin/AuditLog';
import { Users } from './admin/Users';

export function App({ config, userManager }: { config: AppConfig; userManager: UserManager }) {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/access-denied" element={<AccessDenied />} />
      <Route
        path="/admin"
        element={
          <AuthGate config={config} userManager={userManager}>
            <AdminLayout />
          </AuthGate>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="audit" element={<AuditLog />} />
        <Route path="users" element={<Users />} />
      </Route>
      <Route path="/:section" element={<SectionPage />} />
      <Route path="/:section/:name" element={<FormPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
